export default "__VITE_ASSET__d004e1ee__"